import React from 'react';
import ReactDOM from 'react-dom/client';
import { configure } from 'mobx';
import dayjs from 'dayjs';

import duration from 'dayjs/plugin/duration';
import weekday from 'dayjs/plugin/weekday';
import isoWeek from 'dayjs/plugin/isoWeek';
import localeData from 'dayjs/plugin/localeData';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/zh-tw';

import 'normalize.css';
import './index.css';
import 'src/i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';


dayjs.extend(duration);
dayjs.extend(weekday);
dayjs.extend(isoWeek);
dayjs.extend(localeData);
dayjs.locale('zh-tw');
dayjs.extend(utc);
dayjs.extend(timezone);

configure({
  enforceActions: 'always'
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
